import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AttachmentType } from 'src/app/shared/models/misc.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { KakaotalkTemplatesService } from '../../../kakaotalk-templates.service';

@Component({
  selector: 'app-kakaotalk-template-media-header',
  templateUrl: './kakaotalk-template-media-header.component.html',
  styleUrls: ['./kakaotalk-template-media-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KakaotalkTemplateMediaHeaderComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  AttachmentType = AttachmentType;
  supportedMediaTypes = 'image/jpeg,image/png';
  header: {
    media_id: number;
    media_url: string;
    media_type: AttachmentType;
    filename: string;
  } = {} as any;

  uploadImageMediaLabel = this.basicService.translate(
    'parameters/quick_replies/details/graph/kakaotalk_message_with_buttons/edit_box_header_add_image'
  );
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  private subscriptions: Subscription = new Subscription();
  private siteId!: number;

  pictureURL: string;
  isUploading = false;
  uploadProgress$ = new BehaviorSubject<number>(0);

  constructor(
    @Inject('AlertingFactory') private alertingService: any,
    private basicService: BasicService,
    private kakaotalkTemplatesService: KakaotalkTemplatesService,
    private uploadService: UploadService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.kakaotalkTemplatesService.createTemplateSiteIdUpdatedBS.subscribe(siteId => {
        if (siteId) {
          this.siteId = siteId;
        }
      })
    );
  }

  deleteMedia() {
    this.fileInput.nativeElement.value = ''; // allow selecting the same file again
    this.form.reset({
      media_type: AttachmentType.Image,
      media_id: null,
      media_url: null,
      filename: null,
      static: 0,
    });
    this.kakaotalkTemplatesService.headerMediaFileBS.next(null);
    this.form.markAsDirty();
  }

  selectMedia() {
    this.fileInput.nativeElement.value = ''; // allow selecting the same file again
    this.fileInput.nativeElement.click();
  }

  uploadMedia($event) {
    const file = $event.target.files?.item(0);
    this.basicService.showSpinner();
    this.uploadProgress$.next(0);
    this.uploadService
      .uploadPictureAsync(file, this.siteId)
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe((result: any) => {
        const { media_id } = result;
        const mediaUrl = this.uploadService.pictureUrl(media_id);
        this.form.get('media_type').setValue(AttachmentType.Image);
        this.form.get('media_id').setValue(media_id);
        this.form.get('media_url').setValue(mediaUrl);
        this.form.get('static').setValue(this.form.value.static || 0);
        this.form.markAsDirty();
        this.kakaotalkTemplatesService.headerMediaFileBS.next({
          media_id,
          media_url: mediaUrl,
        });
      });
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
